import { makeStyles } from "@material-ui/core/styles";
import { lighten, darken } from "polished";
import {
  secondary,
  grey300,
  white,
} from "../../../../../../../assets/variables.module.scss";

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(2),
  },
  button: {
    backgroundColor: secondary,
    height: 36,
    minWidth: 145,
    color: white,
    borderRadius: 18,
    padding: "0 16px",
    marginLeft: theme.spacing(2),

    "&:hover": {
      backgroundColor: lighten(0.1, secondary),
    },
  },
  disabled: {
    color: darken(0.2, grey300),
    backgroundColor: grey300,
  },
}));

export default useStyles;
